<div #nbsSelectRef class="nbs-select" [ngClass]="getMainClasses()" (click)="openDropDown($event)">
  <div class="nbm-select-notch-outlines">
    <div
      [class]="{
        'nbs-select-notch': true,
        leading: true,
      }"
    ></div>
    <div
      #labelNotchRef
      [class]="{
        'nbs-select-notch': true,
        'nbs-select-required': isRequired,
        center: true,
      }"
    >
      <label #labelRef>{{ label }}</label>
    </div>
    <div
      [class]="{
        'nbs-select-notch': true,
        outline: true,
      }"
    ></div>
  </div>

  <div class="nbm-select-values">
    <div *ngIf="!selectedOptions()?.length" class="values placeholder">
      {{ placeholder || label }}
    </div>

    <div
      *ngIf="selectedOptions() !== undefined && selectedOptions() !== null && selectedOptions()?.length !== 0"
      class="values"
    >
      {{ getDisplayValue() }}
    </div>

    <div style="width: 34px; display: flex; justify-content: center">
      <!-- @if (showLoader) {
        <ion-spinner class="filter-spinner" color="primary" />
      } @else { -->
      <ion-button
        #clearBtnRef
        *ngIf="selectedOptions()?.length > 0 && enableClearAll && !disabled"
        fill="clear"
        (click)="onClearSelection($event)"
      >
        <ion-icon slot="icon-only" name="close-circle-outline" aria-hidden="true"></ion-icon>
      </ion-button>
      <!-- } -->
    </div>

    <div class="arrow" style="width: 11px">
      @if (showLoader) {
        <ion-spinner class="red-spinner" name="circular"></ion-spinner>
      } @else {
        <ion-icon slot="icon-only" name="caret-down" aria-hidden="true"></ion-icon>
      }
    </div>
  </div>
  <div #dropdownHolderRef class="dropdown-holder" (click)="handleClickOutside($event)">
    <div class="dropdown" #dropDownRef>
      <div class="containt">
        <div *ngIf="searchable" class="searchable">
          <input
            #searchBoxRef
            type="text"
            placeholder="Search"
            (input)="onSearchChangeLocal($event)"
            (click)="preventCheckbox($event)"
            autofocus
          />
        </div>
        <cdk-virtual-scroll-viewport
          #contentRef
          itemSize="30"
          style="height: 100%"
          [minBufferPx]="minBufferPx()"
          [maxBufferPx]="maxBufferPx()"
        >
          <div *ngIf="multiSelect === true" class="option" (click)="onSelectAll($event)">
            <ion-checkbox
              [checked]="getSelectAllStatus()"
              [indeterminate]="getSelectAllIndeterminateStatus()"
              alignment="start"
              (ionChange)="onCheckboxClick($event)"
            />
            All
          </div>

          <ng-container
            *cdkVirtualFor="let option of filterOptions(); trackBy: trackByFilterOptionKey; templateCacheSize: 0"
          >
            <!-- You can project or display option data -->
            <!-- [hideCheckBox]="!multiSelect" -->

            <app-nbs-select-dropdown-option
              [value]="option.value"
              [checked]="isSelectedOption(option.value)"
              [hideCheckBox]="!multiSelect"
              [multiSelect]="multiSelect"
              (selectEmitter)="onItemSelection($event)"
              >{{ option.label }}</app-nbs-select-dropdown-option
            >
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
</div>
